<template>
  <div class="space-y-2">
    <div class="flex h-[96px] w-full flex-col rounded-md bg-white shadow-md">
      <div class="flex items-start justify-between px-6 py-4">
        <div class="flex flex-col space-y-5">
          <p class="line-clamp-3 break-all text-gray-400">
            {{
              template.body ??
              $t("ORGANIZATION.COMMUNICATION_TEMPLATES.NO_CONTENT_ADDED")
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex items-center space-x-2">
      <input
        v-if="select"
        :id="`checkbox-${template.id}`"
        type="checkbox"
        :checked="selectedIds.includes(template.id)"
        class="cursor-pointer"
        @input="handleCheckboxInput"
      />
      <label
        :for="`checkbox-${template.id}`"
        class="text font-semibold"
        :class="{ 'cursor-pointer': select }"
      >
        {{ template.name }}
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { EmailTemplate } from "@/models/clients";
import { type PropType } from "vue";

const emit = defineEmits<{
  (eventName: "tile:select", id: EmailTemplate["id"]): void;
}>();

const props = defineProps({
  template: {
    type: Object as PropType<EmailTemplate>,
    required: true
  },
  select: {
    type: Boolean,
    default: false
  },
  selectedIds: {
    type: Array as PropType<EmailTemplate["id"][]>,
    default: () => []
  }
});

const handleCheckboxInput = () => {
  if (!props.select) {
    return;
  }
  emit("tile:select", props.template.id);
};
</script>
